var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooternotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.667,
    height: 24,
    viewBox: "0 0 20.667 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notification_side.e1e710b15a9ce3679791d32d177f9180",
    d: "M10.333,0a2.01,2.01,0,0,0-2,2v.928a7.989,7.989,0,0,0-6,7.739v6a2.333,2.333,0,1,0,0,4.667H8v.333a2.333,2.333,0,0,0,4.667,0v-.333h5.667a2.333,2.333,0,1,0,0-4.667v-6a7.988,7.988,0,0,0-6-7.739V2A2.01,2.01,0,0,0,10.333,0Zm0,1.333A.651.651,0,0,1,11,2v.7c-.218-.018-.443-.032-.667-.032s-.448.013-.667.032V2A.651.651,0,0,1,10.333,1.333ZM17,10.667a6.667,6.667,0,1,0-13.333,0v6H17ZM2.332,18h16a1,1,0,0,1,0,2h-16a1,1,0,0,1,0-2Zm9,3.333h-2v.333a1,1,0,1,0,2,0Z",
    fill: "#f06f00",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooternotification);
export default __webpack_public_path__ + "static/media/footernotification.27986881a95fb87ae1312a9d907cc1e4.svg";
export { ForwardRef as ReactComponent };